import { storyAngles } from '@/mocks/filmData';

export default function StorySection() {
  return (
    <section id="story" className="scroll-mt-20 bg-background-100">
      <div className="px-5 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-3">
              <span className="w-10 h-10 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className="ri-book-open-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="text-xs font-medium tracking-widest text-primary-700 uppercase">Story</span>
            </div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">剧情与看点</h2>
            <div className="mt-4 space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                《善良的小姨子》属于以人物关系和情感抉择为核心的剧情类作品。故事通常从家庭成员之间的日常相处切入，
                逐步展开人物在面对责任、理解与内心选择时的态度变化。
              </p>
              <p>
                这类作品的对白往往承载了大量信息：一句话的语气、一个停顿的轻重，都会影响观众对人物立场的判断。
                因此 <strong className="text-foreground-950">中文字幕</strong> 与
                {' '}<strong className="text-foreground-950">国语配音</strong> 的翻译质量，会直接影响观看体验是否顺畅。
              </p>
              <p>
                如果你习惯保留原声，可优先选择中文字幕或双语版本；如果更看重理解效率，则中文版与国语配音会更省力。
                下面的看点分解可以帮助你判断自己更关注哪一部分。
              </p>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg overflow-hidden border border-background-200 bg-background-50">
              <div className="w-full h-48 md:h-56">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20modern%20illustration%20of%20subtitle%20caption%20bars%20and%20floating%20translation%20layers%20over%20a%20warm%20dark%20background%2C%20amber%20and%20rose%20accents%2C%20minimalist%20editorial%20design%2C%20soft%20grain%20texture%2C%20cinematic%20mood%2C%20elegant%20and%20calm&width=1000&height=700&seq=kind-sister-story-02&orientation=landscape"
                  alt="字幕与译制版本示意图"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <p className="font-heading font-semibold text-foreground-950">观看建议</p>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  先按语言需求选定版本，再根据阅读习惯微调。字幕与译制不是越多越好，合适才最重要。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {storyAngles.map((item) => (
            <div key={item.title} className="rounded-lg bg-background-50 border border-background-200 p-5">
              <span className="w-9 h-9 rounded-md bg-accent-100 text-accent-900 flex items-center justify-center mb-3">
                <i className={`${item.icon} text-base`} aria-hidden="true"></i>
              </span>
              <h3 className="font-heading font-semibold text-base text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}